import { BoolInput } from "../input/BoolInput";
import { EmptyInput } from "../input/EmptyInput";
import { InputData } from "../input/InputData";
import { PHPAdress, PHPAdresses } from "../PHPAdress";
import { PHPRequest } from "../PHPRequest";
import { PHPResponse } from "../PHPResponse";
import { PHPValueResponse } from "../PHPValueResponse";
import { CartEntryListResponse } from "./CartEntryListResponse";
import { CartListInput } from "./CartListInput";


export class GetHideToCartQuestionRequest extends PHPRequest<PHPAdress,EmptyInput,PHPValueResponse<boolean>>
{
  static readonly adress = PHPAdresses.CART_GET_HIDE_TO_CART_QUESTION

  constructor()
  {
    super( GetHideToCartQuestionRequest.adress );
  }
}